export default "__VITE_ASSET__6uLawHXL__"